import { useHistory } from "react-router-dom";

interface SidebarLogoProps {
  logoPath?: string;
}

const SidebarLogo = ({ logoPath }: SidebarLogoProps) => {
  const history = useHistory();

  return (
    <div className="sidebar-header">
      <div className="sidebar-logo">
        <a
          onClick={() => {
            history.push("/tracked_assets");
          }}
          href=" "
        >
          <img src={logoPath} alt={"Home"} />
        </a>
      </div>
    </div>
  );
};

export default SidebarLogo;
